import { createSlice } from "@reduxjs/toolkit";
import { fetchCityById, fetchCityes } from "./citiesFetchService";
import { Notify } from "notiflix";
import { timeout } from "../../../srevices/slider";

const initialState = {
  cities: null,
  cityDetails: null,
  isLoading: false,
  isError: null,
};

const citiesRequest = createSlice({
  name: "citiesRedusers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCityes.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.cities = payload;
      
    });

    builder.addCase(fetchCityes.pending, (state) => {
      state.isLoading = true;
      state.isError = null;
    });

    builder.addCase(fetchCityes.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.isError = payload;
      Notify.failure('Произошла ошибка, попробуйте ещё', timeout);
    });

    builder.addCase(fetchCityById.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchCityById.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.cityDetails = payload;
    });

    builder.addCase(fetchCityById.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.isError = payload;
    });
  },
});

export const citiesReduser = citiesRequest.reducer;
